// eslint-disable-next-line max-len
const googlePixel = '//www.googleadservices.com/pagead/conversion/972021831/?label=YOX1CLihqlYQx8C_zwM&amp;guid=ON&amp;script=0';
const facebookPixel = '//www.facebook.com/tr?ev=6015440162545&amp;cd[value]=0.00&amp;cd[currency]=USD&amp;noscript=1';

const pixelsToFireAfterVerify = [googlePixel, facebookPixel];
export default Object.freeze({ pixelsToFireAfterVerify });
